import React, { useState, useRef, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import CircularCarousel from '../components/CircularCarousel';
import './Home.css';
import TopDestinationCarousel from '../components/TopDestinationCarousel';
import destinations from '../data/destinationsData';
import emailjs from 'emailjs-com';
import { Link } from 'react-router-dom';


const categories = [
  // { name: 'Cruises', image: '/category/cruise.jpg' },
  { name: 'Beaches', image: '/category/beaches.jpg' },
  { name: 'Wildlife', image: '/category/wildlife.jpg' },
  { name: 'Mountains', image: '/category/mountain.jpg' },
  { name: 'Landscape', image: '/category/walking.jpg' },
  { name: 'Adventure', image: '/category/roadtrips.jpg' },
  { name: 'Winter Activities', image: '/category/snowfall.jpg' },
  { name: 'Historical', image: '/category/temples.jpg' },
  // { name: 'Deserts', image: '/category/desert.jpg' },
];

const currentMonth = new Date().toLocaleString('default', { month: 'long' });
const topDestinations = destinations.filter(dest => dest.months.includes(currentMonth)).slice(0, 5);

const testimonials = [
  {
    name: 'Sudeep Kumar R.',
    role: 'CEO, Sirius Star Enterprise Technologies',
    stars: 5,
    text: 'Our 10-day road trip was perfectly planned by Khyati Shah. Her guidance with hotel selection, budget handling, and smooth coordination made the entire journey stress-free.',
  },
  {
    name: 'Saurabh Bhatnagar',
    role: 'Authorized Signatory, StarCrete LLP',
    stars: 5,
    text: 'Sonal Holidays consistently offered unbeatable rates and reliable travel bookings. Their team went out of their way to support us — even while on leave.',
  },
  {
    name: 'Hrushikesh Kolatkar',
    role: 'Director, Building Environment India',
    stars: 5,
    text: 'Khyati Shah helped us save significant costs on our Hyderabad tour. Her quick and cost-effective service proved that every rupee counts.',
  },
  {
    name: 'Miloni',
    role: 'Traveller',
    stars: 5,
    text: 'Everything was so well organised! The pickups and one-day trips were too much fun. We had such a good time — all thanks to you and your amazing team.',
  },
  {
    name: 'Jenica Fichadia',
    role: 'Traveller',
    stars: 5,
    text: 'The trip was perfect — every hotel was amazing, especially Nirjhara! Though we were tired and a bit sick, your constant support made this such a memorable experience.',
  },
];

function Home() {
  const [activeIndex] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [popupImage, setPopupImage] = useState(null);
  const closePopup = () => setPopupImage(null);
  const formRef = useRef();


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'service_xjzs4c8',
      'template_l2h2vwk',
      formRef.current,
      'QYSoXTSzv9lsKSKAm'
    ).then(
      (result) => {
        alert("✅ Your enquiry was sent successfully.");
        e.target.reset();
      },
      (error) => {
        alert("❌ Failed to send your enquiry. Please try again.");
      }
    );
  };


  useEffect(() => {
    const applyScale = () => {
      const slides = document.querySelectorAll(".top-slide");
      slides.forEach((slide, idx) => {
        const diff = Math.abs(activeIndex - idx) % topDestinations.length;
        slide.style.transform = diff === 0
          ? 'scale(1)'
          : diff === 1 || diff === topDestinations.length - 1
          ? 'scale(0.9)'
          : 'scale(0.8)';
        slide.style.transition = 'transform 0.3s ease';
      });
    };
    applyScale();
  }, [activeIndex]);
  

  const navbarRef = useRef(null);
  const [navHeight, setNavHeight] = useState(70);

  useEffect(() => {
    if (navbarRef.current) {
      setNavHeight(navbarRef.current.offsetHeight);
    }
  }, []);

  const contactFormRef = useRef(null);
const contactBgRef = useRef(null);

useEffect(() => {
  const updateBgHeight = () => {
    if (contactFormRef.current && contactBgRef.current) {
      const formBottom = contactFormRef.current.offsetTop + contactFormRef.current.offsetHeight;
      const bgTop = contactBgRef.current.offsetTop;
      const bgHeight = formBottom - bgTop;
      contactBgRef.current.style.height = `${bgHeight}px`;
    }
  };

  requestAnimationFrame(() => {
    setTimeout(updateBgHeight, 50); 
  });

  const resizeObserver = new ResizeObserver(updateBgHeight);
  if (contactFormRef.current) resizeObserver.observe(contactFormRef.current);

  window.addEventListener('resize', updateBgHeight);
  return () => {
    window.removeEventListener('resize', updateBgHeight);
    resizeObserver.disconnect();
  };
}, []);


  return (
    <>
      <Navbar ref={navbarRef} />
      <section
        className="hero-video-section"
        style={{ height: `calc(100vh + ${navHeight}px)` }}
        //style={{ height: `100vh` }}
        //style={{ height: '100vh', marginTop: '-70px', paddingTop: '70px' }}
      >
          <video className="hero-video" autoPlay muted loop playsInline>
            <source src="/hero_mobile.mp4" media="(max-width: 480px)" type="video/mp4" />
            <source src="/hero_tablet.mp4" media="(min-width: 481px) and (max-width: 1024px)" type="video/mp4" />
            <source src="/hero_desktop.mp4" media="(min-width: 1025px)" type="video/mp4" />
          </video>

          <div className="explore-overlay">
            <button className="explore-btn" onClick={() => {
              document.getElementById('destination-section')?.scrollIntoView({ behavior: 'smooth' });
            }}>
              Explore Now
              <div className="down-arrow">↓</div>
            </button>
          </div>
        </section>

        <section className="destination-section" id="destination-section">
          <h4 className="destination-subheading">Wonderful Places For You</h4>
          <h2 className="destination-heading">Destination Categories</h2>
          <CircularCarousel data={categories} />
        </section>


        <TopDestinationCarousel destinations={topDestinations} />
        <section className="trip-planning-section">
        <div className="trip-planning-container">
            <div className="trip-planning-graphic">
            {/* You can place each path in an individual <div> with background-image for custom images */}
            <svg width="648" height="654" viewBox="0 0 648 654" xmlns="http://www.w3.org/2000/svg">
                <defs>
                <pattern id="img1" patternUnits="userSpaceOnUse" width="100%" height="100%">
                    <image href="/plan_your_trip/goabike.jpg" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />
                </pattern>
                <pattern id="img2" patternUnits="userSpaceOnUse" width="100%" height="100%">
                    <image href="/plan_your_trip/plane.jpg" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />
                </pattern>
                <pattern id="img3" patternUnits="userSpaceOnUse" width="100%" height="100%">
                    <image href="/plan_your_trip/road.jpg" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />
                </pattern>
                {/* <pattern id="img4" patternUnits="userSpaceOnUse" width="100%" height="100%">
                    <image href="/roadtrips.jpg" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" />
                </pattern> */}
                </defs>
                <path d="M0 156C0 69.8436 69.8436 0 156 0C242.156 0 312 69.8436 312 156V630H156C69.8436 630 0 560.156 0 474V156Z" fill="url(#img1)" />
                <path d="M648 157.5C648 71.3436 578.156 0 492 0C405.844 0 336 69.8436 336 156V315H492C578.156 315 648 243.656 648 157.5Z" fill="url(#img2)" />
                <path d="M336 496.5C336 582.656 405.844 654 492 654C578.156 654 648 584.156 648 498V339H492C405.844 339 336 410.344 336 496.5Z" fill="url(#img3)" />
                {/* <!-- Optional fourth shape below if needed --> */}
            </svg>
            </div>
            <div className="trip-planning-content">
            <h4 className="trip-tagline">Let’s Go Together</h4>
            <h2 className="trip-title">Plan Your Trip With Us</h2>
            <p className="trip-description">
                From romantic getaways to family vacations and solo adventures—our travel experts are here to build your dream itinerary with care, creativity, and custom solutions.
            </p>
            <div className="trip-services">
                <div className="trip-service">
                    <i className="fa-solid fa-route trip-icon"></i>
                    <div>
                    <h4>Tailored Itineraries</h4>
                    <p>Every journey customized for your needs.</p>
                    </div>
                </div>
                <div className="trip-service">
                    <i className="fa-solid fa-suitcase-rolling trip-icon"></i>
                    <div>
                    <h4>Hassle-Free Experience</h4>
                    <p>We manage bookings, transfers, & stays.</p>
                    </div>
                </div>
                <div className="trip-service">
                    <i className="fa-solid fa-headset trip-icon"></i>
                    <div>
                    <h4>Dedicated Travel Expert</h4>
                    <p>1-on-1 planning with our specialists.</p>
                    </div>
                </div>
                <div className="trip-service">
                    <i className="fa-solid fa-hotel trip-icon"></i>
                    <div>
                    <h4>Curated Stays</h4>
                    <p>Only handpicked resorts and hotels.</p>
                    </div>
                </div>
                </div>

            <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="trip-cta">Learn More →</Link>
            </div>
        </div>
        </section>
        <section className="recent-gallery-section">
            <svg className="gallery-line" width="1920" height="860" viewBox="0 0 1920 860" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2138 14.0506C2095.27 -17.4415 2002.06 10.9842 1886.26 120.726C1741.5 257.904 1351.09 392.927 1300.98 262.785C1236.52 95.3792 1538.14 78.636 1447.87 346.052C1357.6 613.468 810.026 408.273 376.356 511.519C46.7827 589.983 -27.4648 825.017 -14.6451 859" stroke="#E9F6F9" strokeWidth="4"/>
            </svg>
            <h4 className="gallery-subheading">Snapshots of Moments We Cherish</h4>
            <h2 className="gallery-heading">Recent Gallery</h2>

        
            
            <div className="gallery-wrapper">
                <div className="gallery-grid">
                {[...Array(7)].map((_, i) => (
                  <div
                    key={i}
                    className={`gallery-box box-${i + 1}`}
                    style={{
                      backgroundImage: `url("/Recent_Gallery/pic${i + 1}.jpeg")`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                    }}
                    onClick={() => setPopupImage(`/Recent_Gallery/pic${i + 1}.jpeg`)}
                  ></div>
                ))}

                </div>
            </div>
        </section>

        {popupImage && (
          <div className="gallery-popup-overlay" onClick={closePopup}>
            <div className="gallery-popup-content" onClick={(e) => e.stopPropagation()}>
              <button className="gallery-popup-close" onClick={closePopup}>×</button>
              <img src={popupImage} alt="Popup View" />
            </div>
          </div>
        )}

        {/* Testimonial Section */}
        <section className="testimonial-section">
  <h4 className="testimonial-subheading">Testimonial</h4>
  <h2 className="testimonial-heading">What Client Say About Us</h2>

  <div className="testimonial-carousel-wrapper">
    <Swiper
      modules={[Pagination]}
      pagination={{
        el: '.testimonial-pagination',
        clickable: true,
      }}
      spaceBetween={20}
      slidesPerView={1.2}
      breakpoints={{
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      }}
      centeredSlides
      onSlideChange={(swiper) => setTestimonialIndex(swiper.realIndex)}
    >
      {testimonials.map((t, i) => (
        <SwiperSlide key={i}>
          <div className={`testimonial-card ${i === testimonialIndex ? 'active' : ''}`}>
            <div className="testimonial-profile">
              {/* <div className="avatar"></div> */}
              <div>
                <h4>
                  {t.name}
                  <span className="testimonial-stars">{'★'.repeat(t.stars)}</span>
                </h4>
                <p>{t.role}</p>
              </div>
            </div>
            <p className="testimonial-text">“{t.text}”</p>
            <div className="testimonial-quote">99</div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    <div className="testimonial-pagination"></div>
  </div>
</section>


        <section className="hotel-tieups-section">
          <h2 className="hotel-tieups-heading">Hotel Tie ups</h2>
          <div className="hotel-logos">
            <img src="/Hotel_tie_up/Taj.png" alt="Taj Hotels" />
            <img src="/Hotel_tie_up/Trident.png" alt="Trident Hotels" />
            <img src="/Hotel_tie_up/oberoi.png" alt="Oberoi Hotels & Resorts" />
            <img src="/Hotel_tie_up/stregis.png" alt="St. Regis" />
            <img src="/Hotel_tie_up/jw.png" alt="JW Marriott" />
          </div>
        </section>
        <section className="contact-wrapper">
  <div className="contact-bg-wrapper" ref={contactBgRef}>
    <div className="contact-inner">
      <div className="contact-home-left">
        <h4 className="contact-home-subheading">Get in touch</h4>
        <h2 className="contact-home-heading">Say Hello To Us</h2>
        <p className="contact-home-text">
          We’d love to hear from you. Our friendly team is always here to chat.
        </p>
      </div>
      <div className="contact-form-container">
        <div className="contact-form-card" ref={contactFormRef}>
          <form ref={formRef} onSubmit={sendEmail}>
  <div className="input-group">
    <input type="text" placeholder="First Name" name="name" required />
    <i className="fa-regular fa-user"></i>
  </div>
  <div className="input-group">
    <input type="email" placeholder="Your Mail" name="email" required />
    <i className="fa-regular fa-envelope"></i>
  </div>
  <div className="input-group">
    <select name="title" required>
      <option value="">Select Tour Type</option>
      <option value="Domestic">Domestic</option>
      <option value="International">International</option>
    </select>
    <i className="fa-solid fa-chevron-down"></i>
  </div>
  <div className="input-group">
    <textarea placeholder="Your Message" name="message" required></textarea>
    <i className="fa-regular fa-message"></i>
  </div>
</form>

        </div>
        <div className="form-footer">
          <button
  className="send-button"
  onClick={() => formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))}
>
  Send Message <i className="fa-regular fa-paper-plane"></i>
</button>
          <div className="phone">+91 97737 49023 <i className="fa-solid fa-phone"></i></div>
        </div>
      </div>
    </div>
  </div>
</section>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>
<Footer />
      
    </>
  );
}

export default Home;
